var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-option"},[_c('router-link',{attrs:{"to":_vm.link},nativeOn:{"click":function($event){return _vm.refresh.apply(null, arguments)}}},[_c('i',{class:'icon fas ' + _vm.icon}),_c('span',{staticClass:"title-section"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }